<script>
    import SvelteTable from "../../../Components/Common/SvelteTable.svelte";

    import { CardLayout } from "../../../Components/Common/index.svelte";

    import {
        getFormatDate,
        viewLog,
    } from "../../../Utils/utilFunctions.svelte";
    import { LogTypes } from "../../../Utils/utilEnums.svelte";

    export let eclipseLogsData = [];
    export let totalEclipseLogs = 0;

    const LIMIT_TEXT_LENGTH = 200;

    const columns = [
        {
            key: "createdDate",
            title: "Date",
            headerClass: "text-left pl-3 cursor-pointer w-[10%] rounded-tl-xl",
            class: "text-left px-3 cursor-pointer w-[10%]",
            renderValue: (v) => getFormatDate(v.createdDate),
        },
        {
            key: "description",
            title: "Description",
            headerClass: "text-left pl-3 cursor-pointer w-[15%]",
            class: "text-left px-3 cursor-pointer w-[15%]",
            renderValue: (v) => _getTextWithTrim(v.description),
        },
        {
            key: "transactionId",
            title: "Transaction ID",
            headerClass: "text-left pl-3 cursor-pointer w-[15%]",
            class: "text-left px-3 cursor-pointer w-[15%]",
            renderValue: (v) => _getTextWithWrap(v.transactionId),
        },
        {
            key: "request",
            title: "Request",
            headerClass: "text-left pl-3 cursor-pointer w-[60%] rounded-tr-xl",
            class: "text-left px-3 cursor-pointer w-[60%]",
            renderValue: (v) => _getTextWithTrim(v.request),
        },
    ];

    const handleClickCell = ({ target: { className } }, rowData, key) => {
        viewLog(LogTypes.Eclipse, rowData.id);
    };

    const handleClickCol = ({ target: { className } }, colData, key) => {};

    // HELPER FUNCTIONS
    const _getTextWithTrim = (text) => {
        const displayText =
            text.length <= LIMIT_TEXT_LENGTH
                ? text
                : text.slice(0, LIMIT_TEXT_LENGTH) + "...";

        return `
                <div class="w-full break-all">
                    ${displayText}
                </div>
                `;
    };

    const _getTextWithWrap = (text) => {
        return `
                <div class="w-full break-all">
                    ${text ? text : "-"}
                </div>
                `;
    };
</script>

<CardLayout title={`Eclipse Logs (${totalEclipseLogs})`}>
    {#if eclipseLogsData.length}
        <div class="overflow-auto">
            <SvelteTable
                {columns}
                rows={eclipseLogsData}
                clickCellFunc={({ detail: { event, row, key } }) => {
                    handleClickCell(event, row, key);
                }}
                clickColFunc={({ detail: { event, row, key } }) => {
                    handleClickCol(event, row, key);
                }}
            />
        </div>
    {:else}
        <div class="grid flex-1 h-full card bg-white rounded-box">
            <div class="flex flex-col flex-1 px-2 py-4 w-full lg:flex-row">
                <p>No eclipse logs</p>
            </div>
        </div>
    {/if}
</CardLayout>

<style>
    .transition {
        transition: 0.5s linear;
    }
</style>
